import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="lux-footer">

      {/* BACKGROUND VIDEO */}
      {/*
      <video
        className="lux-footer-video"
        src="/videos/v3.mp4"
        autoPlay
        muted
        loop
        playsInline
      />
      */}

      {/* OVERLAY */}
      <div className="lux-footer-overlay" />

      <div className="lux-footer-inner">

        {/* TOP SECTION */}
        <div className="lux-footer-grid">

          {/* BRAND */}
          <div className="lux-footer-brand">
            <h2>SMARTVIZX</h2>
            <p>
              Designing bespoke environments where creativity and
              functionality meets technology. We craft spatial
              experiences that elevate how people connect, interact,
              and feel.
            </p>
          </div>

          {/* PRODUCTS */}
          <div className="lux-footer-card">
            <h3>Products</h3>
            <ul>
              <li>
                <a
                  href="https://trezi.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  Trezi Platform
                </a>
              </li>
            </ul>
          </div>

          {/* COMPANY */}
          <div className="lux-footer-card">
            <h3>Company</h3>
            <ul>
              <li>
                <a href="/about">Team</a>
              </li>
              <li>
                <a href="/career">Careers</a>
              </li>
              <li>
                <a href="/press">Press</a>
              </li>
              <li>
                <a href="/privacy">Privacy</a>
              </li>
            </ul>
          </div>

          {/* SOCIAL */}
          <div className="lux-footer-card">
            <h3>Connect</h3>

            <div className="lux-socials">
              {[
                {
                  href: "https://www.linkedin.com/company/smartvizs-pvt-ltd-/",
                  icon: "linkedin",
                },
                {
                  href: "https://www.facebook.com/smartvizx/",
                  icon: "facebook",
                },
                {
                  href: "https://twitter.com/ByTrezi",
                  icon: "twitter",
                },
                {
                  href: "https://www.instagram.com/smartvizx/",
                  icon: "instagram",
                },
                {
                  href: "https://www.youtube.com/channel/UCnAGo5MdsIyM9UIDn7_ouOg",
                  icon: "youtube",
                },
              ].map(({ href, icon }) => (
                <a
                  key={icon}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={`/img/svg/${icon}.svg`}
                    alt={icon}
                  />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* BOTTOM STRIP */}
        <div className="lux-footer-bottom">
          <p>
            2025 SMARTVIZX — Crafted with precision & vision
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;